import React from 'react';
import { Plugin, CustomEditor } from '../types';

const EmojiPlugin: Plugin = {
  name: 'emoji',
  
  commands: {
    insertEmoji: (editor: CustomEditor, emoji: string) => {
      // Insert emoji at current selection
      const { insertText } = editor;
      insertText(emoji);
    }
  }
};

export default EmojiPlugin; 